import { ItemData } from "../../_helpers/list-selector/list-selector-item/list-selector-item";

export const filesToListItemsData = (files: string[] | File[]): ItemData[] => {
  const itemsData: ItemData[] = [];
  files.forEach(file => {
    const itemId = typeof file === "string" ? file : file.name;
    const itemValue = typeof file === "string" ? file : file.name;
    const itemIcon: string = undefined;
    const itemChecked: boolean = false;
    itemsData.push({
      itemId: itemId,
      itemValue: itemValue,
      itemIcon: itemIcon,
      itemChecked: itemChecked
    });
  });
  return itemsData;
};
